import React from "react"
import Card from "@material-ui/core/Card"
import Button from "@material-ui/core/Button"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import Image from "./image"

interface IProps {
  service: Service
}

interface Service {
  title: string
  image: string
  description: string
  url: string
}

const useStyles = makeStyles(() => ({
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    border: "1px solid rgba(35, 51, 72, 0.08)",
    borderRadius: 8,
    boxShadow: "0 10px 24px rgba(35, 51, 72, 0.07)",
    transition: "transform 160ms ease, box-shadow 160ms ease",
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "0 16px 32px rgba(35, 51, 72, 0.12)",
    },
  },
  actions: {
    marginTop: "auto",
    padding: "0 16px 16px",
  },
  content: {
    padding: 20,
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
  },
  title: {
    marginBottom: 8,
    lineHeight: 1.25,
  },
  description: {
    lineHeight: 1.55,
  },
}))

const ServiceCard = ({ service }: IProps) => {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <Image
        alt={service.title}
        filename={service.image}
        style={{ width: "100%" }}
        imgStyle={{ objectFit: "contain" }}
      />
      <CardContent className={classes.content}>
        <Typography variant="h6" color="inherit" className={classes.title}>
          {service.title}
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          component="p"
          className={classes.description}
        >
          {service.description}
        </Typography>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button
          size="small"
          color="primary"
          href={service.url}
          aria-label={`Read more: ${service.title}`}
        >
          Read more
        </Button>
      </CardActions>
    </Card>
  )
}
export default ServiceCard
